<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="拆分工单"
      edit-title
      id-key="UserId"
      form-label-width="85px"
      @opened="onOpened"
      @close-saved="$emit('close-saved')"
    >
      <div class="flex">
        <div>
          <span class="span-top-text">待拆分工单</span>
        </div>
        <el-button type="primary" @click="openWorkList">添加</el-button>
      </div>
      <el-table
        class="table_bottom table-line tb-c-head"
        border
        :data="tableData"
      >
        <el-table-column
          prop="DocDate"
          label="老单据日期"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="WorkDocNo"
          label="老工单号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ProductName"
          label="存货名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="MouldName"
          label="模具名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="PropertyName"
          label="属性"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="Quantity"
          label="数量"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="StageName"
          label="加工阶段"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ProgrammeName"
          label="工艺方案"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="_split(row)"
              >拆分</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="flex">
        <div>
          <div class="span-top-text">新工单列表</div>
        </div>
      </div>

      <el-table
        class="table_bottom table-line tb-c-head"
        border
        :data="newTableData"
      >
        <el-table-column prop="DocDate" label="新单据日期" min-width="120">
          <template slot-scope="{ row }">
            <el-date-picker v-model="row.DocDate" type="date" placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column> 
        <el-table-column
          prop="WorkDocNo"
          label="新工单号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ProductName"
          label="存货名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="MouldName"
          label="模具名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="PropertyName"
          label="属性"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="Quantity" label="数量" min-width="120">
          <template slot-scope="{ row }">
            <el-input type="number" v-model="row.Quantity" v-int @change="changeQuantity($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="StageName"
          label="加工阶段"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="ProgrammeName"
          label="工艺方案"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ $index }">
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="del($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div>
        <div class="flex">
          <div>子件</div>
        </div>
        <el-table :data="workDocMaterialsList" class="table_bottom table-line tb-c-head" border>
          <el-table-column
            prop="ProductNo"
            label="子件编码"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ProductName"
            label="子件名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="PropertyName"
            label="子件属性"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="ColorName"
            label="子件颜色"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="Quantity"
            label="子件数量"
            min-width="120"
          ></el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
    <work-list ref="workList" :type="false" @saved="saved"></work-list>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import workList from "../common/workList";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    workList,
  },
  data() {
    return {
      child: [],
      tableData: [],
      newTableData: [],
      workDocMaterialsList: [],
      api: require('@/api/production/workDoc').default,
      // trendData: iForm.Data,
    };
  },

  methods: {
    onOpened(){
      this.tableData = [];
      this.newTableData = [];
      this.workDocMaterialsList = [];
      this.child = [];
    },
    _split() {
      let o = {
        DocDate: "",
        WorkDocNo: "",
        ProductName: this.tableData[0].ProductName,
        MouldName: this.tableData[0].MouldName,
        PropertyName: this.tableData[0].PropertyName,
        ColorName: this.tableData[0].ColorName,
        Quantity: 0,
        ProcessStageDesc: this.tableData[0].ProcessStageDesc,
        ProgrammeName: this.tableData[0].ProgrammeName,
        StageName: this.tableData[0].StageName,
      };
      this.newTableData.push(o);

      this.workDocMaterialsList = this.child;
    },
    openWorkList() {
      this.$refs.workList.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    del(index) {
      this.newTableData.splice(index, 1)
      if(this.newTableData.length === 0){
        this.workDocMaterialsList = [];
      }
    },
    changeQuantity(val, row){
      val = Number(val);
      row.Quantity = val;
    },
    save(){
      let DocDates = this.newTableData.filter(itme => {
        return itme.DocDate === "";
      })
      if(DocDates.length !== 0){
        this.$message({type: 'warning', message: '请填写单据日期'});
        return
      }
      var sum = this.newTableData.reduce((pre, cur) => {
        return pre + cur.Quantity;
      }, 0);
      if(sum !== Number(this.tableData[0].Quantity)){
        this.$message({type: 'warning', message: '新工单列表数量总和需等于旧工单数量'});
        return
      }

      let SplitWorkDocChildList = this.newTableData.map(item => {
        return {
          DocDate: item.DocDate,
          Quantity: item.Quantity
        }
      })

      let o = {
        WorkDocId: this.tableData[0].WorkDocId,
        SplitWorkDocChildList,
      }


      this.api.splitWorkDoc(o).then(res => {
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg});
          this.$emit('saved')
          this.child = [];
          this.tableData = [];
          this.workDocMaterialsList = [];
          this.newTableData = [];
          this.close(true)

        }else{
          this.$message({type: 'warning', message: res.Msg});
        }
      })
    },
    saved(list) {
      console.log('list===', list)
      this.tableData = [];
      this.child = []
      let {WorkDocMaterialsList, ...rest} = list[0];


      this.tableData.push(rest)
      this.child = WorkDocMaterialsList

    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  margin: 18px;
  justify-content: space-between;
  align-items: center;
}
</style>
